<!-- <div class="kt-section">
	<div class="kt-section__content">
			<div class="modal-header">
				<h4 class="modal-title">
					{{_data.productItems.kod}} - {{_data.productItems.name}}
				</h4><br />
				
				<button type="button" class="close" aria-label="Close" (click)="close()">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body sktLot">
				<div class="form-group">
					
					<div *ngIf="!(hideProductListByVariation | async)">

						<kt-custom-description [description]="desc">
						</kt-custom-description>

						<div [ngClass]="(isTotalCount | async) ? 'customBorderByStokNumber': '' ">
							<h5 class="text-success">Total Stok Sayısı: {{noVariationTotalStock}}</h5>
						</div>
					</div>
					<table class="table table-striped responsive" wt-responsive-table *ngIf="!(hideProductListByVariation | async)">
						<thead>
							<tr>
								<th>SKT</th>
								<th>LOT</th>
								<th>Barcode</th>
								<th *ngIf="_data.stokView">Stok</th>
								<th width="150">Talep Adedi Giriniz</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let product of (products | async)">
								<td>
									{{product.expirationDate ? product.expirationDate : '-'}}
								</td>
								<td>
									{{product.lot ? product.lot : '-'}}
								</td>
								<td>
									{{product.barcode ? product.barcode : '-'}}
								</td>
								<td *ngIf="_data.stokView">
									{{product.stok}}
								</td>
								<td>
									<input type="number"
										   class="form-control"
										   [ngStyle]="{'border-color': product.orderedQty > 0 ? 'blue': ''}"
										   placeholder="Miktar giriniz"
										   [(ngModel)]="product.orderedQty"
										   name="qty"
										   (blur)="onBlurStokControlByOrderedQty(product)"
										   value=""
										   min="0"
										   oninput="this.value = Math.abs(this.value)" />
								</td>
							</tr>

						</tbody>
					</table>
					<div class="row" *ngIf="(hideProductListByVariation | async)">
						<div class="col-md-12 text-center text-danger margin-top-10">
							<h5>Bu üründe skt ve lot bilgisi bulunmamaktadır..</h5>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" (click)="close()">Kapat</button>
				<button type="button" class="btn btn-primary" (click)="onClickSave()">Kaydet</button>
			</div>
	</div>
</div> -->



<div class="kt-section">
    <div class="kt-section__content">
        <!-- <ng-template #content5 let-c="close" let-d="dismiss"> -->
            <div class="modal-header">
                <h4 class="modal-title">
					{{_data.productItems.kod}} - {{_data.productItems.name}}
				</h4>
                <button type="button" class="close" aria-label="Close" (click)="close()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
				<div *ngIf="!(hideProductListByVariation | async)">

                <kt-custom-description [description]="desc">
				</kt-custom-description>
				
				</div>

                <div class="row sktLot-2" *ngIf="!(hideProductListByVariation | async)">
                    <div class="col-md-7">
                        <div class="form-group row">
							<label class="col-lg-12 col-form-label">{{ 'FE.ORDERS.EXPIRATIONDATELOTMODAL.LABELS.VARIATION' | localize }}</label>
                            <div class="col-lg-12 kt-margin-b-10-tablet-and-mobile">
								<mat-select class="form-control"
											[(value)]="selectVariationProduct"
											(selectionChange)="onChangeVariationProduct()"
											placeholder="{{ 'FE.ORDERS.EXPIRATIONDATELOTMODAL.PLACEHOLDERS.VARIATION' | localize }}"
											required>
									<mat-option disabled>
										<table class="table table-striped responsive" wt-responsive-table>
											<thead>
												<tr>
													<th width="120">{{ 'FE.ORDERS.EXPIRATIONDATELOTMODAL.COMBOBOX.VARIATION.TH1' | localize }}</th>
													<th width="120">{{ 'FE.ORDERS.EXPIRATIONDATELOTMODAL.COMBOBOX.VARIATION.TH2' | localize }}</th>
													<th width="140">{{ 'FE.ORDERS.EXPIRATIONDATELOTMODAL.COMBOBOX.VARIATION.TH3' | localize }}</th>
												</tr>
											</thead>
										</table>
									</mat-option>

									<!--placeholder="11.12.2020 / C-456 / 1011284-01"-->

									<mat-option
												*ngFor="let product of (products | async); index as i"
												[value]="product"
												[ngClass]="{'gridBackground': i % 2 == 0}"
												>
										<table class="table table-striped responsive vrt-table" wt-responsive-table>
											<tbody>
												<tr>

													<td width="120">
														{{product.lot ? product.lot : '-'}}
													</td>

													<td width="120">
														{{product.expirationdate ? product.expirationdate : '-'}}
													</td>

													<td width="140">
														{{product.barcode ? product.barcode : '-'}}
													</td>
												</tr>
											</tbody>
										</table>
									</mat-option>

								</mat-select>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group row">
							<label class="col-lg-12 col-form-label">{{ 'FE.ORDERS.EXPIRATIONDATELOTMODAL.LABELS.STOCK' | localize }}</label>
                            <div class="col-lg-12 margin-top-10 kt-margin-b-10-tablet-and-mobile stock">
								{{selectVariationProduct?.stok ? selectVariationProduct.stok : '-'}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group row">
							<label class="col-lg-12 col-form-label">{{ 'FE.ORDERS.EXPIRATIONDATELOTMODAL.LABELS.ORDEREDQTY' | localize }}</label>
                            <div class="col-lg-12 kt-margin-b-10-tablet-and-mobile">
								<input 
								type="number" 
								class="form-control"
								[(ngModel)]="orderedQty"
								[ngStyle]="{'border-color': orderedQty > 0 ? 'blue': ''}"
								(blur)="onBlurStokControlByOrderedQty()"
								placeholder="{{ 'FE.ORDERS.EXPIRATIONDATELOTMODAL.PLACEHOLDERS.ORDEREDQTY' | localize }}"
								min="0"
								oninput="this.value = Math.abs(this.value)"/>
                            </div>
                        </div>
					</div>
					
					
				</div>
				
				<div class="row" *ngIf="(hideProductListByVariation | async)">
					<div class="col-md-12 text-center text-danger margin-top-10">
						<h5>{{ 'FE.INFOMESSAGE.ORDERS.SPECIALCODEVARIATIONMODAL.NOTFOUNDEXPIRATIONORLOT' | localize }}</h5>
					</div>
				</div>

            </div>
            <div class="modal-footer">
				<button type="button" class="btn btn-secondary" (click)="close()">{{ 'FE.ORDERS.EXPIRATIONDATELOTMODAL.BUTTONS.CLOSE' | localize }}</button>
				<button type="button" class="btn btn-primary" (click)="onClickSave()" *ngIf="!(hideProductListByVariation | async)">{{ 'FE.ORDERS.EXPIRATIONDATELOTMODAL.BUTTONS.SAVE' | localize }}</button>
            </div>
        <!-- </ng-template> -->
    </div>
</div>
